export default class NetworkErrorEventModel {
    public static readonly EVENT_NAME = "network-error-event";

    httpStatusCode: number;
    message: string;
}
